<script setup>
import successLogo from '@/assets/images/success_cheers.png'
import { translate } from '@/plugins/i18n.js'
import { computed } from 'vue'

const props = defineProps({
  data: {
    type: String || undefined,
    required: true
  }
})

const orderId = computed(() => props.data)
</script>

<template>
  <div
    class="pt-4 w-100 align-md-start align-center justify-center d-flex flex-column flex-md-row"
    no-gutters
  >
    <VImg
      :src="successLogo"
      class="flex-grow-0"
      alt="people cheering"
      width="100%"
      max-width="300"
      height="auto"
    />
    <div
      class="d-flex flex-column align-md-start align-center text-md-start pl-md-8 pl-0 pt-5 pt-md-0"
    >
      <h2 class="font-weight-bold font-weight-bold font-size-md-xxxl">
        {{ translate('checkout:page_title_success') }}
      </h2>
      <div class="py-2 font-weight-bold font-weight-bold font-size-md-xl">
        {{ translate('checkout:wip') }}
      </div>
      <div class="py-4 font-size-l font-size-md-xl">
        {{ translate('checkout:order_nr') }}
        <span class="font-weight-bold">{{ orderId }}</span>
      </div>
      <VBtn
        data-elbaction="click"
        data-elb="home"
        data-elbcontext="shopping:discover"
        :to="'/'"
        class="my-2"
      >
        {{ translate('checkout:back_to_start') }}
      </VBtn>
    </div>
  </div>
</template>
